/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  const contentType = response.headers.get('content-type')
  if (contentType && contentType.indexOf('application/json') !== -1) {
    return response.json().catch(error => {
      return {}
    })
  } else {
    return Promise.resolve({})
  }
}

function redirect(body) {
  if (body && typeof body.redirect === 'string') {
    // If the response has a redirect key, update the current browser URL
    global.location.href = body.redirect
  }

  return body
}

async function handleError(response) {
  const error = new Error(response.statusText)
  const body = await parseJSON(response)

  switch (response.status) {
    case 401:
    case 403:
      // Unauthorized, expected errors, so don't log as error
      break
    default:
      // eslint-disable-next-line no-console
      console.error(error)
      break
  }

  // Perform a redirect if necessary
  redirect(body)

  return Promise.reject({ message: error.message, error, response, body })
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
export function checkStatus(response) {
  if (response.ok) return response
  return handleError(response)
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    ...options,
  })
    .then(checkStatus)
    .then(parseJSON)
    .then(redirect)
}



// WEBPACK FOOTER //
// ./src/utils/request.js